import React, { ReactElement, useEffect, useState } from 'react';
import { Col, Heading, Row } from 'idsk-react-components';
import { useLocation, useNavigate, useParams } from 'react-router';
import AddPripomienkaForm from './AddPripomienkaForm';
import ClassType from '../../../model/pripomienka/ClassType';
import SavePripomienka from '../../../model/pripomienka/SavePripomienka';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import { useClient } from '../../../context/ClientStatusContext';
import { addPripomienka } from '../../../client/addPripomienkaClient';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import routes from '../../../routing/routes';
import { useUserContext } from '../../../context/UserContext';
import { useActionContext } from '../../../context/ConfirmActionContext';

interface Props {
  classType: ClassType;
}

const AddPripomienkaComponent = ({
  classType,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const navigate = useNavigate();
  const { pouzivatel, legislationProcess, fetchProfile } = useUserContext();
  const { displaySuccess } = useSuccessMessageContext();

  const [pripomienka, setPripomienka] = useState<SavePripomienka>({
    clanok: '',
    paragraf: '',
    odsek: '',
    celyMaterial: false,
    ine: '',
    text: '',
    zasadna: false,
  });

  const { status, wrapClient } = useClient(addPripomienka);
  const { getFieldErrorMessage, clearFieldErrorMessage } = useFieldErrorMessages();
  const { cancelAction, visible } = useActionContext();
  const location = useLocation();

  useEffect(() => {
    if (visible === true) {
      cancelAction();
    }
    // trigger only on pripomienka change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pripomienka]);

  const updateField: SafeParameterSetter<SavePripomienka> = (fieldName, value) => {
    setPripomienka(prevState => ({ ...prevState, [fieldName]: value }));
    clearFieldErrorMessage(fieldName);
    if (fieldName === 'ine' || fieldName === 'odsek' || fieldName === 'paragraf'
      || fieldName === 'clanok' || fieldName === 'celyMaterial') {
      clearFieldErrorMessage('pripomienkaK');
    }
  };

  const handleReset = (): void => {
    const hasPreviousState = location.key !== 'default';
    if (hasPreviousState) {
      navigate(-1);
    } else if (classType === ClassType.PRIPOMIENKA) {
      navigate(routes.pripomienky.list.withParams(type, year, index));
    } else {
      navigate(routes.hromadnePripomienky.list.withParams(type, year, index));
    }
  };

  const handleSubmit = async (): Promise<void> => {
    await wrapClient(
      classType,
      type,
      year,
      index,
      pripomienka,
    );
    fetchProfile(type, year, index);
    if (classType === ClassType.PRIPOMIENKA) {
      navigate(routes.pripomienky.list.withParams(type, year, index));
      displaySuccess('Pripomienka bola úspešne pridaná.');
      setTimeout(() => {
        window.parent.postMessage({
          type: 'scroll-to',
          top: 0,
        }, '*');
      }, 500);
    } else {
      navigate(routes.hromadnePripomienky.list.withParams(type, year, index));
      displaySuccess('Hromadná pripomienka bola úspešne pridaná.');
      setTimeout(() => {
        window.parent.postMessage({
          type: 'scroll-to',
          top: 0,
        }, '*');
      }, 500);
    }
  };
  return (
    <>
      <Row className="row">
        <Col width="one-quarter">
          <span className="information-header">Názov LP: </span>
        </Col>
        <Col width="three-quarters">
          <p>
            {legislationProcess?.nazovPredpisu}
          </p>
        </Col>
      </Row>
      <section className="organizacia-pripomienky-section">
        <Row className="row-heading">
          <Col width="one-quarter">
            <Heading size="m">PRIPOMIENKOVATEĽ</Heading>
          </Col>
        </Row>
        <Row className="row">
          <Col width="one-quarter">
            <span className="information-header">Pripomienkujúci subjekt:</span>
          </Col>
          <Col width="three-quarters">
            <p>{pouzivatel?.organizaciaMeno}</p>
          </Col>
        </Row>
      </section>
      <section className="udaje-pripomienky-section">
        <Row className="row-heading">
          <Col>
            <Heading size="m">ÚDAJE PRIPOMIENKY</Heading>
          </Col>
        </Row>
        <AddPripomienkaForm
          classType={classType}
          getFieldErrorMessage={getFieldErrorMessage}
          onUpdateField={updateField}
          onSubmit={handleSubmit}
          onReset={handleReset}
          pripomienka={pripomienka}
          saveLoading={status.loading}
        />
      </section>
    </>
  );
};
export default AddPripomienkaComponent;
